import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ListLinkBox from '../../../components/UI/ListLinkBox';
import { translate } from '../../../utils/util';
import { checkPermission } from '../../../services/auth';
import { PERMISSIONS } from '../../../utils/constants';
import * as actionsInventory from '../../../actions/inventoryAction';

const Inventory = (props) => {
    const menu = () => {
        let menuItems = [];
        if (checkPermission(PERMISSIONS.Inventory.General.Access)) {
            menuItems = [...menuItems, {
                route: { pathname: 'inventory/general/inventory', state: { typeInventory: 'G' } },
                icon: 'mdi mdi-alpha-g-circle-outline',
                text: translate('inventory:menu.general'),
                onClick: () => {
                    const filter = props.filter;
                    filter.typeInventory = 'G';
                    props.setFilter(filter);
                }
            }];
        }

        if (checkPermission(PERMISSIONS.Inventory.Rotative.Access)) {
            menuItems = [...menuItems, {
                route: { pathname: 'inventory/rotative/inventory', state: { typeInventory: 'R' } },
                icon: 'mdi mdi-alpha-r-circle-outline',
                text: translate('inventory:menu.rotative'),
                onClick: () => {
                    const filter = props.filter;
                    filter.typeInventory = 'R';
                    props.setFilter(filter);
                }
            }];
        }

        if (checkPermission(PERMISSIONS.Inventory.General.Audit)) {
            menuItems = [...menuItems, { route: 'inventory/report', icon: 'mdi mdi-clipboard-list-outline', text: translate('inventory:menu.report') }];
        }

        if (checkPermission(PERMISSIONS.Inventory.ReenvioSIM)) {
            menuItems = [...menuItems, {
                route: 'inventory/log',
                icon: 'mdi mdi-file-alert-outline',
                text: 'Logs Envio SIM',
                onClick: () => {
                    props.clearLogs();
                }
            }];
        }

        return menuItems;
    };

    return (
        <div>
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-clipboard-check-outline" />
                        {translate('inventory', 'inventory')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilter: (filter) => {
            dispatch(actionsInventory.setFilterInventoryLot(filter));
        },
        clearLogs: () => {
            dispatch(actionsInventory.setLogs([]));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Inventory)));
